import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { WaitingListPage } from "@/pages/dashboard/employees/waiting-list";

export const Route = createFileRoute("/_main/dashboard/waiting-list")({
  component: () => (
    <RequirePermission action="employees.read">
      <WaitingListPage />
    </RequirePermission>
  ),
});
